import type { TicketState } from './palette.ts';

export interface BoardEmptyOpts {
  /** True when the toolbar filter is narrowing the board. */
  filterActive: boolean;
  /** Tickets in this column that the filter hid. */
  hiddenCount: number;
}

/**
 * What an empty column is allowed to say.
 *
 * The unfiltered copy names a global fact ("Nobody is blocked."). With a filter active that
 * sentence is a lie: the blocked ticket still exists, it just does not match. A filtered
 * empty column may only say that nothing matched — and, when the filter hid cards, how many.
 */
export function emptyLine(state: TicketState, opts: BoardEmptyOpts = { filterActive: false, hiddenCount: 0 }): string {
  if (opts.filterActive) {
    return opts.hiddenCount > 0
      ? `No matches in this column · ${opts.hiddenCount} hidden by the filter`
      : 'No matches in this column';
  }
  switch (state) {
    case 'Waiting':
      return 'Nobody is blocked.';
    case 'Merging':
      return 'Nothing landing right now.';
    case 'Human Review':
      return 'Nothing waiting for a merge.';
    case 'Done':
      return 'Nothing merged yet.';
    case 'Backlog':
      return 'Nothing shelved. Create a ticket, then Start it — or drag it to Refining.';
    case 'Implementing':
      return 'No agent is writing code right now.';
    case 'AI Review':
      return 'Nothing under review.';
    default:
      return 'Empty.';
  }
}
